import { render, staticRenderFns } from "./DeleteGroup.vue?vue&type=template&id=6af82bbc&scoped=true"
import script from "./DeleteGroup.vue?vue&type=script&lang=js"
export * from "./DeleteGroup.vue?vue&type=script&lang=js"
import style0 from "./DeleteGroup.vue?vue&type=style&index=0&id=6af82bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af82bbc",
  null
  
)

export default component.exports